/**
 * @generated SignedSource<<61797a41711754fbf95cfddf3cf1d7f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadPurposeEnum = "applicant_feedback" | "hiring";
export type SendChatMessageInput = {
  chatAutomationId?: string | null | undefined;
  chatBotId?: string | null | undefined;
  chatThreadId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  jobId?: string | null | undefined;
  message: string;
  purpose?: ChatThreadPurposeEnum | null | undefined;
  recipientId?: string | null | undefined;
};
export type ChatThreadActions_SendMutation$variables = {
  input: SendChatMessageInput;
};
export type ChatThreadActions_SendMutation$data = {
  readonly sendChatMessage: {
    readonly chatMessage: {
      readonly chatThread: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ChatDialogContent_Thread" | "ChatThreadMessages_Thread" | "ChatThreadUsers_Thread">;
      };
      readonly message: string;
      readonly user: {
        readonly guest: boolean;
        readonly id: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ChatMessage_Message">;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadActions_SendMutation = {
  response: ChatThreadActions_SendMutation$data;
  variables: ChatThreadActions_SendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guest",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "generatedByAi",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  },
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "JobApplicationEvaluation",
  "kind": "LinkedField",
  "name": "jobApplicationEvaluation",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplication",
      "kind": "LinkedField",
      "name": "jobApplication",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Job",
          "kind": "LinkedField",
          "name": "job",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isRecipient"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "self",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatContact",
  "kind": "LinkedField",
  "name": "chatContact",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v19 = [
  (v3/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "sender",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v3/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "type": "User",
      "abstractKey": null
    },
    (v20/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v16/*: any*/),
        (v21/*: any*/)
      ],
      "type": "ChatBot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatThread",
  "kind": "LinkedField",
  "name": "directChatThread",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v25 = [
  (v24/*: any*/)
],
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadActions_SendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendChatMessagePayload",
        "kind": "LinkedField",
        "name": "sendChatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessage",
            "kind": "LinkedField",
            "name": "chatMessage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatMessage_Message"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatThread",
                "kind": "LinkedField",
                "name": "chatThread",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatDialogContent_Thread"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatThreadMessages_Thread"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatThreadUsers_Thread"
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadActions_SendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendChatMessagePayload",
        "kind": "LinkedField",
        "name": "sendChatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessage",
            "kind": "LinkedField",
            "name": "chatMessage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatThread",
                "kind": "LinkedField",
                "name": "chatThread",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "purpose",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultTitle",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "recipient",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timezoneName",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isProfileFeedback",
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v16/*: any*/),
                          (v3/*: any*/)
                        ],
                        "type": "ChatBot",
                        "abstractKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRoom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableMeetingRoom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "threadType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v23/*: any*/),
                              (v17/*: any*/),
                              (v14/*: any*/),
                              (v18/*: any*/)
                            ],
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v23/*: any*/),
                              (v21/*: any*/)
                            ],
                            "type": "ChatBot",
                            "abstractKey": null
                          }
                        ],
                        "type": "Recipient",
                        "abstractKey": "__isRecipient"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "messagesNotFromSelf",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "excludeSelf": true
                        }
                      }
                    ],
                    "concreteType": "ChatMessageConnection",
                    "kind": "LinkedField",
                    "name": "chatMessages",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": "chatMessages(filters:{\"excludeSelf\":true})"
                  },
                  {
                    "alias": "unreadMessages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "unread": true
                        }
                      }
                    ],
                    "concreteType": "ChatMessageConnection",
                    "kind": "LinkedField",
                    "name": "chatMessages",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": "chatMessages(filters:{\"unread\":true})"
                  },
                  {
                    "alias": null,
                    "args": (v26/*: any*/),
                    "concreteType": "ChatMessageConnection",
                    "kind": "LinkedField",
                    "name": "chatMessages",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatMessageEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChatMessage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v22/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "chatMessages(first:5)"
                  },
                  {
                    "alias": null,
                    "args": (v26/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "ChatThreadMessages_chatMessages",
                    "kind": "LinkedHandle",
                    "name": "chatMessages"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "joined",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "muted",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "269ec1764a31fc0578df4cfd0f5d4901",
    "id": null,
    "metadata": {},
    "name": "ChatThreadActions_SendMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadActions_SendMutation(\n  $input: SendChatMessageInput!\n) {\n  sendChatMessage(input: $input) {\n    chatMessage {\n      message\n      ...ChatMessage_Message\n      chatThread {\n        id\n        ...ChatDialogContent_Thread\n        ...ChatThreadMessages_Thread\n        ...ChatThreadUsers_Thread\n      }\n      user {\n        id\n        guest\n      }\n      id\n    }\n  }\n}\n\nfragment ChatDialogContent_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadTitle_Recipient\n  ...ChatThreadActions_Recipient\n}\n\nfragment ChatDialogContent_Thread on ChatThread {\n  id\n  purpose\n  ...ChatThreadTitle_Thread\n  ...ChatThreadActions_Thread\n  recipient {\n    __typename\n    ...ChatDialogContent_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatMessage_Message on ChatMessage {\n  id\n  label\n  createdAt\n  message\n  ...ChatThreadItem_ChatMessage\n  sender {\n    __typename\n    ...ChatThreadItem_Contact\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadActions_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n  }\n  ... on ChatBot {\n    id\n  }\n  ...ChatThreadEditDialog_Recipient\n}\n\nfragment ChatThreadActions_Thread on ChatThread {\n  id\n  threadType\n  purpose\n  ...ChatThreadEditDialog_Thread\n  recipient {\n    __typename\n    ...ChatThreadActions_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadEditDialog_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n  }\n  ... on ChatBot {\n    id\n    name\n  }\n}\n\nfragment ChatThreadEditDialog_Thread on ChatThread {\n  id\n  title\n  avatarUrl\n  purpose\n  recipient {\n    __typename\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n  }\n}\n\nfragment ChatThreadItem_ChatMessage on ChatMessage {\n  id\n  deletedAt\n  editedAt\n  label\n  generatedByAi\n  jobApplicationEvaluation {\n    id\n    jobApplication {\n      job {\n        slug\n        id\n      }\n      id\n    }\n  }\n  sender {\n    __typename\n    ... on User {\n      self\n      firstName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadItem_Contact on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    name\n  }\n  ... on ChatBot {\n    name\n  }\n  ...RecipientAvatar_Recipient\n  ...chat_useContactDescription\n}\n\nfragment ChatThreadMessages_Messages_VbLdN on ChatThread {\n  chatMessages(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...ChatMessage_Message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ChatThreadMessages_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    firstName\n    isProfileFeedback\n  }\n  ... on ChatBot {\n    name\n  }\n  ...ChatThreadItem_Contact\n}\n\nfragment ChatThreadMessages_Thread on ChatThread {\n  id\n  purpose\n  messagesNotFromSelf: chatMessages(filters: {excludeSelf: true}) {\n    totalCount\n  }\n  unreadMessages: chatMessages(filters: {unread: true}) {\n    totalCount\n  }\n  recipient {\n    __typename\n    ...ChatThreadMessages_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...ChatThreadMessages_Messages_VbLdN\n}\n\nfragment ChatThreadSettingsButton_Thread on ChatThread {\n  id\n  enableMeetingRoom\n}\n\nfragment ChatThreadSubheader_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    id\n    timezoneName\n  }\n  ... on ChatBot {\n    id\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment ChatThreadTitle_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    name\n    firstName\n    avatarUrl\n    profile {\n      slug\n      id\n    }\n  }\n  ... on ChatBot {\n    avatarUrl\n    name\n  }\n  ...RecipientAvatar_Recipient\n  ...ChatThreadSubheader_Recipient\n}\n\nfragment ChatThreadTitle_Thread on ChatThread {\n  title\n  defaultTitle\n  avatarUrl\n  recipient {\n    __typename\n    ...ChatThreadTitle_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...JoinVideoCallButton_Thread\n  ...ChatThreadSettingsButton_Thread\n}\n\nfragment ChatThreadUsers_Thread on ChatThread {\n  id\n  joined\n  threadType\n  purpose\n  muted\n  recipient {\n    __typename\n    ... on User {\n      id\n    }\n    ... on ChatBot {\n      id\n    }\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n    ...Contact_Contact\n  }\n  ...ChatThreadEditDialog_Thread\n}\n\nfragment Contact_Contact on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ... on ChatBot {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ...RecipientAvatar_Recipient\n  ...chat_useContactDescription\n}\n\nfragment JoinVideoCallButton_Thread on ChatThread {\n  meetingRoom\n  enableMeetingRoom\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useContactDescription on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    chatContact {\n      description\n      id\n    }\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d653deaca867358969de444f7d6adbc";

export default node;
